<template>
  
  <div class="ibox">
    <div class="ibox-title">
      <h2>Copy Agency</h2>
    </div>
    <div :class="'ibox-content p-md'+ (panelLoading ? ' sk-loading' : '')">

      <div v-if="panelLoading" class="sk-spinner sk-spinner-double-bounce">
          <div class="sk-double-bounce1"></div>
          <div class="sk-double-bounce2"></div>
      </div>

      <form role="form" @submit="onFormSubmit" name="copyAgencyForm">
        <div class="form-group row">
          <div class="col">
            <v-select :options="listDBs" :getOptionLabel="listDBsOptionLabel" v-model="form.originDB" placeholder="Select an origin DB" @keypress.enter.native.prevent="">
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!form.originDB"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
          <div class="col">
            <v-select :options="listAgencies" v-model="form.agency" :getOptionLabel="option => option.agency.name" placeholder="Select a agency" @keypress.enter.native.prevent="">
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!form.agency"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <v-select :options="listDBs" :getOptionLabel="listDBsOptionLabel" v-model="form.destinationDB" placeholder="Select a destination DB" @keypress.enter.native.prevent="">
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!form.destinationDB"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
          <div class="col">
            <SwitchCheck 
                v-bind:value.sync="form.includeApartments" 
                id="copyIncludeApartments" 
                label="Include apartments"
                :labelAsColumn="true"
            />
            <SwitchCheck 
                v-bind:value.sync="form.includeAvailabilities" 
                id="copyIncludeAvailabilities" 
                label="Include availabilities"
                :labelAsColumn="true"
            />
            <SwitchCheck 
                v-bind:value.sync="form.includeBookings" 
                id="copyIncludeBookings" 
                label="Include bookings"
                :labelAsColumn="true"
            />
            <SwitchCheck 
                v-bind:value.sync="form.keepBookingUnavailablePeriods" 
                id="copyKeepBookingUnavailablePeriods" 
                label="Keep bookings in unavailable periods"
                :labelAsColumn="true"
            />
          </div>
        </div>
        <div class="form-group row">
          <div class="col">
            <button class="btn btn-primary ladda-button" data-style="zoom-in" type="submit">Copy</button>
          </div>
        </div>
      </form>

      

    </div>
  </div>
        
</template>

<style scoped>
  
</style>



<script lang="ts">
import Vue from '@fwk-node-modules/vue';
import { Component, Watch } from '@fwk-node-modules/vue-property-decorator';
import * as api from '@fwk-client/utils/api';
import SwitchCheck from '@fwk-client/components/panels/input/SwitchCheck.vue';

@Component({
  components: {
    SwitchCheck
  }
})
export default class Copy extends Vue {

  listDBs:any[] = [];

  listPathPrefix:any[] = [
    "dev-staging",
    "dev-production",
    "staging",
    "production"
  ];

  listAgencies:any[] = [];

  form:any = {
    agency:"",
    originDB:"",
    destinationDB:"",
    includeApartments:true,
    includeAvailabilities:false,
    keepBookingUnavailablePeriods:false,
    includeBookings:false
  }

  panelLoading:boolean = false;

  created() {
    this.updateListDBs();
  }

  onFormSubmit(evt:Event) {
    evt.preventDefault();

    var options:api.ApiVueOptions =  {
      app: this
    }

    var input = {
      agencyID : this.form.agency.agency._id,
      originDB : this.form.originDB.title,
      destinationDB : this.form.destinationDB.title,
      includeApartments : this.form.includeApartments,
      includeAvailabilities : this.form.includeAvailabilities,
      keepBookingUnavailablePeriods : this.form.keepBookingUnavailablePeriods,
      includeBookings : this.form.includeBookings
    }

    this.panelLoading = true;

    return api.postAPI('/api/admin/hospitality/agencies/copy', input,  options).then((response:any) => {
      this.panelLoading = false;
    })
  }

  updateListAgencies() {
    // We need to get the list of available companies for the current logged in user
    var options:api.ApiVueOptions =  {
      app: this
    }

    var input = {
      targetDB : this.form.originDB.title
    }

    return api.postAPI('/api/admin/hospitality/agencies/list', input, options).then((response:any) => {
      if(response.agencies) {  
        this.listAgencies = response.agencies;
      }
      else {
        this.listAgencies = [];
      }
    });
  }

  updateListDBs() {
    // We need to get the list of available companies for the current logged in user
    var options:api.ApiVueOptions =  {
      app: this
    }
    this.panelLoading = true;
    api.getAPI('/api/admin/database/configs', options).then((response:any) => {
      if(response.configs) {  
        this.listDBs = response.configs;
      }
      else {
        this.listDBs = [];
      }
      this.panelLoading = false;
    });
  }

  listDBsOptionLabel(option:any) {
    return option.title;
  }

  @Watch('form.originDB')
  onValueChange(val: any, oldVal: any) {
    if(val == null) {
      this.listAgencies = [];
    }
    else {
      this.updateListAgencies();
    }
  }
  
}
</script>